import { Component, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

// TODO: Add Angular decorator.
@Component({
    selector: '',
    template: '',
    standalone: false
})
export abstract class CreateServiceBase implements OnDestroy
{
    protected destroyator = new Subject();
    public currentLang: string;
    abstract onSubmit (): void;

    /**
     *
     */
    constructor (
        protected translateService: TranslateService
    )
    {
        this.currentLang = translateService.currentLang;
    }

    ngOnDestroy (): void
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    protected markControlsDirty (group: UntypedFormGroup | UntypedFormArray): void
    {
        group.updateValueAndValidity();
        for (const ctrlKey in group.controls)
        {
            const abstractControl = group.controls[ctrlKey];

            if (abstractControl instanceof UntypedFormGroup || abstractControl instanceof UntypedFormArray)
            {
                this.markControlsDirty(abstractControl);
            }
            else
            {
                abstractControl.markAsDirty();
            }
        }
    }
}
